import { Component, OnInit, Input, EventEmitter, Output, Inject, PLATFORM_ID } from '@angular/core';
import { ScheduledResource, ScheduleItemStatusEnum, ScheduleItemTypeEnum } from '../aims-scheduler.classes';
import { SchScheduleItemType, HrEmployees, SchResources, SchClearance, EngOverAndAboveProjects, SchFirearms, HrEmploymentStatus, InvAttachedItem, FacEquipment, InvScheduleItemXAsset, AccCopas } from '../../../../../../src/models';
import { TransferHttpService } from '../../../../../../src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../../../../src/app/services/permissions/permissions.service';
import { map } from 'rxjs/operators';
import { combineLatest, BehaviorSubject, Observable } from 'rxjs';

import * as moment from 'moment-mini';
import { ScheduleItem } from '../../../../../../src/app/containers/scheduling/schCommon';
import { AimsHub } from '../../../../../../src/app/components/aimsHub/aimsHub';
import { AimsCommonPopupEditorComponent, AimsCommonPopupEditorData, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { FormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { InventoryReturnPopupComponent } from 'src/app/containers/assetMgmt/workorders/workOrder/inventory-return-popup/inventory-return-popup.component';
import { MatDialog } from '@angular/material/dialog';

// enum LoadType {
//   FillGap,
//   LoadExisting,
//   New
// }

@Component({
  selector: 'aims-schedule-item-editor',
  templateUrl: './aims-schedule-item-editor.component.html',
  styleUrls: ['./aims-schedule-item-editor.component.scss'],
  exportAs: 'schItemEditor',
  providers: [AimsHub]
})
export class AimsScheduleItemEditorComponent implements OnInit {

  public formGroup: any;

  constructor(
      private contentData: AimsCommonPopupEditorData,
      private transferHttp: TransferHttpService,
      @Inject(PLATFORM_ID) private platformId: Object,
      public permissions: PermissionsService,
      private dialog: MatDialog,
      public trLegHub: AimsHub) {
    this.formGroup = contentData.formGroup;
    this.scheduleItemToEdit = contentData.contentData.itemToEdit;
    this.yearSched = contentData.contentData.yearSched;

    this.formGroup.addControl('scheduleItemId', new FormControl({ value: this.scheduleItemToEdit.scheduleItemId, disabled: true } ));
    this.formGroup.addControl('reliefForJtId', new FormControl({ value: this.scheduleItemToEdit.reliefForJtId, disabled: true }, Validators.required));

    let newOrEditable: boolean = this.isNewSch(this.scheduleItemToEdit) || this.calculateEditable();

    this.formGroup.addControl('scheduleItemTypeId', new FormControl( { value: this.scheduleItemToEdit.scheduleItemTypeId,
                                                                       disabled: !newOrEditable }, Validators.required));
    this.formGroup.addControl('reliefForId', new FormControl( { value: this.scheduleItemToEdit.reliefForId,
                                                                       disabled: !newOrEditable }, Validators.required));
    this.formGroup.addControl('overhireJtId', new FormControl( { value: this.scheduleItemToEdit.overhireJtId,
                                                                       disabled: !newOrEditable }, Validators.required));

    this.formGroup.addControl('siteArrivalNoticeRequired', new FormControl( { value: this.scheduleItemToEdit.siteArrivalNoticeRequired, disabled: !newOrEditable || this.scheduleItemToEdit.siteId == null } ));

    this.formGroup.addControl('scheduleItemStart', new FormControl( { value: this.scheduleItemToEdit.scheduleItemStart,
                  disabled: !newOrEditable || (this.scheduleItemToEdit.scheduleItemTypeId == null ||
                            (this.checkSiTypeOH(this.scheduleItemToEdit.scheduleItemTypeId) && this.scheduleItemToEdit.overhireJtId == null) ||
                            (this.checkSiTypeRel(this.scheduleItemToEdit.scheduleItemTypeId) && this.scheduleItemToEdit.reliefForId == null) )
                  }, Validators.required));
    this.formGroup.addControl('scheduleItemEnd', new FormControl( { value: this.scheduleItemToEdit.scheduleItemEnd,
                  disabled: !newOrEditable || this.scheduleItemToEdit.scheduleItemStart == null }, Validators.required));
    this.formGroup.addControl('siteId', new FormControl( { value: this.scheduleItemToEdit.siteId,
                  disabled: !newOrEditable || this.scheduleItemToEdit.scheduleItemEnd == null }, Validators.required));

    this.formGroup.addControl('employeeId', new FormControl( { value: this.scheduleItemToEdit.employeeId,
                  disabled: !newOrEditable || this.scheduleItemToEdit.scheduleItemEnd == null }, Validators.required));

    this.formGroup.addControl('resourceId', new FormControl( { value: this.scheduleItemToEdit.resourceId,
                  disabled: !newOrEditable || this.scheduleItemToEdit.siteId == null }, Validators.required));

    let disabledControl:boolean = !newOrEditable || (this.scheduleItemToEdit.employeeId == null && this.scheduleItemToEdit.resourceId == null);

    this.formGroup.addControl('travelArrangeReq', new FormControl( { value: this.scheduleItemToEdit.travelArrangeReq, disabled: disabledControl } ));
    this.formGroup.addControl('govBilled', new FormControl( { value: this.scheduleItemToEdit.govBilled, disabled: disabledControl } ));
    this.formGroup.addControl('companyBilled', new FormControl( { value: this.scheduleItemToEdit.companyBilled, disabled: disabledControl } ));
    this.formGroup.addControl('purpose', new FormControl( { value: this.scheduleItemToEdit.purpose, disabled: disabledControl } ));
    this.formGroup.addControl('meals', new FormControl( { value: this.scheduleItemToEdit.meals, disabled: disabledControl } ));
    this.formGroup.addControl('billeting', new FormControl( { value: this.scheduleItemToEdit.billeting, disabled: disabledControl } ));
    this.formGroup.addControl('notes', new FormControl( { value: this.scheduleItemToEdit.notes, disabled: disabledControl } ));
    this.formGroup.addControl('oanumber', new FormControl( { value: this.scheduleItemToEdit.oanumber, disabled: disabledControl } ));
    this.formGroup.addControl('copanumber', new FormControl( { value: this.scheduleItemToEdit.copaId, disabled: disabledControl } ));

    this.formGroup.addControl('classifiedAccess', new FormControl( { value: this.scheduleItemToEdit.classifiedAccess, disabled: disabledControl } ));
    this.formGroup.addControl('restrictedAccess', new FormControl( { value: this.scheduleItemToEdit.restrictedAccess, disabled: disabledControl } ));
    this.formGroup.addControl('comsecaccess', new FormControl( { value: this.scheduleItemToEdit.comsecaccess, disabled: disabledControl } ));
    this.formGroup.addControl('teraccess', new FormControl( { value: this.scheduleItemToEdit.teraccess, disabled: disabledControl } ));
    this.formGroup.addControl('escortOnly', new FormControl( { value: this.scheduleItemToEdit.escortOnly, disabled: disabledControl } ));
    this.formGroup.addControl('restrictedAreaPhotography', new FormControl( { value: this.scheduleItemToEdit.restrictedAreaPhotography, disabled: disabledControl } ));
    this.formGroup.addControl('radarDowntime', new FormControl( { value: this.scheduleItemToEdit.radarDowntime, disabled: disabledControl } ));
    this.formGroup.addControl('transToTopCamp', new FormControl( { value: this.scheduleItemToEdit.transToTopCamp, disabled: disabledControl } ));
    this.formGroup.addControl('firearmRequest', new FormControl( { value: this.scheduleItemToEdit.firearmRequest, disabled: disabledControl } ));

    this.formGroup.addControl('clearanceId', new FormControl( { value: this.scheduleItemToEdit.clearanceId, disabled: true } ));
    this.formGroup.addControl('modifiedById', new FormControl( { value: this.scheduleItemToEdit.modifiedById, disabled: true } ));

    this.formGroup.addControl('scheduleItemStatusId', new FormControl( { value: this.scheduleItemToEdit.scheduleItemStatusId, disabled: !this.permissions.canUpdate(this.permissions.ComponentID.ScheduleApproval) || this.scheduleItemToEdit.employeeId == this.user.employeeId} ));

    this.formGroup.addControl('carrierId', new FormControl( { value: this.scheduleItemToEdit.carrierId, disabled: this.scheduleItemToEdit.siteId == null} ));
    this.formGroup.addControl('arrivalCarrierSchItemId', new FormControl( { value: this.scheduleItemToEdit.arrivalCarrierSchItemId, disabled: this.scheduleItemToEdit.siteId == null} ));
    this.formGroup.addControl('departureCarrierSchItemId', new FormControl( { value: this.scheduleItemToEdit.departureCarrierSchItemId, disabled: this.scheduleItemToEdit.siteId == null} ));
    this.formGroup.addControl('flightNumber', new FormControl( { value: this.scheduleItemToEdit.flightNumber, disabled: this.scheduleItemToEdit.carrierId == null} ));

    this.formGroup.addControl('equipmentIdToAdd', new FormControl( { value: this.equipmentIdToAdd, disabled: false } ));

    // no visual control
    this.formGroup.addControl('addTR', new FormControl( { value: false, disabled: false } ));
    this.formGroup.addControl('jtWsId', new FormControl( { value: this.scheduleItemToEdit.jtWsId, disabled: false } ));
  }

  // public findInvalidControls() {
  //   const invalid = [];
  //   const controls = this.formGroup.controls;
  //   for (const name in controls) {
  //       if (controls[name].invalid) {
  //           invalid.push(name);
  //       }
  //   }
  //   console.log(invalid);
  //   return invalid;
  // }

  // Grid
  firearmsTableHeader: AimsCommonTableHeader[] = [
    { key: 'edit', label: 'Edit', type: AimsCommonTableHeaderType.EDIT_BUTTON,  },
    { key: 'approve', label: '', type: 'dynamic', width: 80,
            editable: this.permissions.canCreate(this.permissions.ComponentID.FirearmApproval), },
    { key: 'disapprove', label: '', type: 'dynamic', width: 80,
            editable: this.permissions.canCreate(this.permissions.ComponentID.FirearmApproval), },
    { key: 'make', label: 'Make', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [ Validators.required] },
    { key: 'model', label: 'Model', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [ Validators.required] },
    { key: 'caliber', label: 'Caliber', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [ Validators.required] },
    { key: 'serialNumber', label: 'Serial #', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [ Validators.required] },
  ];
  firearmsTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    filter: false
  }
  updateFirearmsTablePermissions() {
    this.firearmsTablePermissions.create = this.calculateEditable();
    this.firearmsTablePermissions.update = this.calculateEditable();
   }

  public handleFirearmRowUpdate(update: TableRowUpdate): void {
    const updatedFirearm: SchFirearms = update.newRow as SchFirearms;
    this.scheduleItemToEdit.schFirearms[update.index] = updatedFirearm;
    this.scheduleItemToEdit.schFirearms = [...this.scheduleItemToEdit.schFirearms];
    this.formGroup.markAsDirty();
  }

  public handleFirearmRowAdd(update: TableRowUpdate){
    const item: SchFirearms = update.newRow as SchFirearms;
    this.scheduleItemToEdit.schFirearms = [item, ...this.scheduleItemToEdit.schFirearms];
    this.formGroup.markAsDirty();
  }

  public handleFirearmRowDelete(deleted: TableRowDelete) {
    this.scheduleItemToEdit.schFirearms.splice(deleted.index, 1);
    this.scheduleItemToEdit.schFirearms = [...this.scheduleItemToEdit.schFirearms];
    this.formGroup.markAsDirty();
  }

  user = this.transferHttp.getCache('user');

  siType = ScheduleItemTypeEnum;
  siStatus = ScheduleItemStatusEnum;

  employmentStatuses = this.transferHttp.getSingle<Array<HrEmploymentStatus>>('HR/GetEmploymentStatus');

  // Add Asset
  attachedAssets: InvScheduleItemXAsset [] = [];
  equipmentList = this.transferHttp.getSingle<Array<FacEquipment>>('Common/GetEquipment');
  filteredEquip = [];
  equipmentIdToAdd: number = 0;

  assetsTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Delete Asset', type: 'editButton', filter: false },
    { key: 'equipment.equipmentIdOld', label: 'Asset ID', type: 'string', filter: false, editable: false },
    { key: 'equipment.equipmentGroup.equipmentGroup', label: 'Asset Group', type: 'string', filter: false, editable: false },
    { key: 'equipment.description', label: 'Description', type: 'string', width: 300, filter: false, editable: false }
  ];

  assetsTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: true,
    delete: true,
    filter: false
  };

  public assetChange(event) {
    this.showSpinner = true;
    // add asset to schedule item
    var url = `Inventory/AddAssetToScheduleItem?scheduleItemId=${this.scheduleItemToEdit.scheduleItemId}&assetId=${event.equipmentId}`;
    this.transferHttp.put(url, null)
      .subscribe(retVal => {
      this.loadAttachedAssets(this.scheduleItemToEdit.scheduleItemId);
      });
      this.equipmentIdToAdd = null;
  }

  public loadAttachedAssets(scheduleItemId: number) {
    if (!this.inventoryAllowed() || scheduleItemId == 0) {
      return;
    }

    this.showSpinner = true;
    this.transferHttp.get(`Inventory/GetScheduleItemAssets?scheduleItemId=${scheduleItemId}` ).subscribe(retval => {
          this.attachedAssets = retval;
          this.showSpinner = false;
        });
  }

  public detachAsset(event) {
    this.removeAssetFromScheduleItem(event.row.attachedAssetId);
  }

  private removeAssetFromScheduleItem(attachedAssetId: number) : void {
    this.showSpinner = true;

    var url = `Inventory/RemoveAssetFromScheduleItem?attachedAssetId=${attachedAssetId}`;
    this.transferHttp.put(url, null)
      .subscribe(retVal => {
        this.loadAttachedAssets(this._scheduleItemToEdit.scheduleItemId);
    });
  }
  // end Asset

  private _scheduleItemToEdit: ScheduleItem;
  @Input() set scheduleItemToEdit(value: ScheduleItem) {
    this._scheduleItemToEdit = value;

    if (value && value.scheduleItemId) {
      this.loadAttachedItems(value.scheduleItemId);
      this.loadAttachedAssets(value.scheduleItemId);
    }

    this.updateFirearmsTablePermissions();
  }

  get scheduleItemToEdit(): ScheduleItem {
    return this._scheduleItemToEdit;
  }

  //@Input() yearSched: Array<ScheduledResource>;
  yearSched: Array<ScheduledResource>;

  @Output() updatedSI: EventEmitter<ScheduleItem> = new EventEmitter();

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //Only sort by travelLeg when the legs are on the same travel request
  trLegData: Observable<any[]>;

  defaultFirearm: SchFirearms = new SchFirearms();

  cloning: boolean = false;
  emps = this.transferHttp.getCache<Array<HrEmployees>>('employeeDropdown');
  reliefForId: BehaviorSubject<number> = new BehaviorSubject(null);
  overhireJtId: BehaviorSubject<number> = new BehaviorSubject(null);

  siteValues = this.transferHttp.getSingle('Sch/GetScheduleAndTravelSites');
  employeeValues = this.transferHttp.getSingle('Sch/GetAllEmployeesForLookUp').pipe(
    map(empArr => empArr.map(e => {
      e.occDate = moment(e.occDate).format('YYYY-MM-DD');
      return e;
    }))
  );
  resourceValues = this.transferHttp.getSingle<Array<SchResources>>('Sch/GetResourcesForLookUp');
  clearanceValues = this.transferHttp.getSingle<Array<SchClearance>>('Sch/GetClearance');
  scheduleItemTypeValues = this.transferHttp.getSingle<Array<SchScheduleItemType>>('Sch/GetScheduleItemType');
  scheduleItemStatusValues = this.transferHttp.getSingle<Array<SchScheduleItemType>>('Sch/GetScheduleItemStatus');
  oaNumberValues = this.transferHttp.getSingle<Array<EngOverAndAboveProjects>>('Sch/GetOverAndAboveProjectsForDropdown');
  activeOaNumberValues = this.transferHttp.getSingle<Array<EngOverAndAboveProjects>>('Sch/GetActiveOverAndAboveProjectsForDropdown');
  jobTitleValues = this.transferHttp.getSingle('Common/GetAllJobTitlesForLookUp');
  workSectionValues = this.transferHttp.getSingle('Common/GetAllWorkSectionsForDropdown');
  copas = this.transferHttp.getSingle<Array<AccCopas>>('Common/GetCopas');

  scheduleItemTypeArr: Array<SchScheduleItemType>;

  carrierValues = this.resourceValues.pipe(
    map(rArr => rArr.filter(r => r.isCarrier))
  );

  carriersArriving: Array<any> = [];

  carriersDeparting: Array<any> = [];

  setCarriers(siteId: number, start: Date, end: Date) {
    if (this.yearSched !== undefined && this.yearSched !== null) {

      this.carriersArriving = this.yearSched.filter(c => c.scheduleItemTypeId == ScheduleItemTypeEnum.flight && c.siteId == siteId &&
                                                           moment(c.start).isSame(moment(start), 'day'));
      this.carriersArriving.map(c => <any>c) //convert to any so we can set start, end to string
        .map(c => {
          c.start = moment(c.start).format("MM/DD/YYYY hh:mm a");
          c.end = moment(c.end).format("MM/DD/YYYY hh:mm a");
        });
      this.carriersDeparting = this.yearSched.filter(c => c.scheduleItemTypeId == ScheduleItemTypeEnum.flight && c.siteId == siteId && moment(c.end).isSame(moment(end), 'day'));
      this.carriersDeparting.map(c => <any>c) //convert to any so we can set start, end to string
        .map(c => {
          c.start = moment(c.start).format("MM/DD/YYYY hh:mm a");
          c.end = moment(c.end).format("MM/DD/YYYY hh:mm a");
        });
    }
  }

  public cloneSI() {
    this.cloning = true;

    this.scheduleItemToEdit.scheduleItemId = 0;
    this.scheduleItemToEdit.schTravelRequestLegs = [];
    this.scheduleItemToEdit.reliefForId = null;
    this.scheduleItemToEdit.travelArrangeReq = false;
    this.scheduleItemToEdit.oanumber = null;
    this.scheduleItemToEdit.copaId = null;
    this.scheduleItemToEdit.modifiedById = null;
    this.scheduleItemToEdit.modifiedOn = null;
    this.scheduleItemToEdit.firearmRequest = false;
    this.scheduleItemToEdit.schFirearms = [];
    this.scheduleItemToEdit.notes = null;
    this.scheduleItemToEdit.confirmArrival = null;
    this.scheduleItemToEdit.confirmDeparture = null;
    this.scheduleItemToEdit.scheduleItemStatusId = ScheduleItemStatusEnum.pending;

    this.formGroup.patchValue({
      scheduleItemId :  this.scheduleItemToEdit.scheduleItemId,
      reliefForId : this.scheduleItemToEdit.reliefForId,
      travelArrangeReq : this.scheduleItemToEdit.travelArrangeReq,
      oanumber : this.scheduleItemToEdit.oanumber,
      copanumber : this.scheduleItemToEdit.copaId,
      modifiedById : this.scheduleItemToEdit.modifiedById,
      modifiedOn : this.scheduleItemToEdit.modifiedOn,
      firearmRequest : this.scheduleItemToEdit.firearmRequest,
      notes : this.scheduleItemToEdit.notes,
      confirmArrival : this.scheduleItemToEdit.confirmArrival,
      confirmDeparture : this.scheduleItemToEdit.confirmDeparture,
      scheduleItemStatusId : this.scheduleItemToEdit.scheduleItemStatusId
    } , {onlySelf:true} );

    this.formGroup.markAsDirty();
  }

  public inventoryAllowed(): boolean {
    return this.permissions.canUpdate(this.permissions.ComponentID.Inventory);
  }

  public calculateEditable(): boolean {
    let returnVal = this.permissions.canUpdate(this.permissions.ComponentID.Scheduler);

    if (this.scheduleItemToEdit?.scheduleItemStatusId == ScheduleItemStatusEnum.approved) {
      returnVal = false;
    }
    return returnVal;
  }

  filteredEmps = combineLatest([this.employeeValues, this.reliefForId,this.employmentStatuses]).pipe(
    map(([emps, rf, empStat]) => emps.filter(e => {
      const s = this.scheduleItemToEdit;
      const activeEmpStatIds = empStat.filter(es => es.isActiveStatus).map(es => es.employmentStatusId);

      if (s.scheduleItemId == 0) {
        // Filter by employment status not employee status
        if (rf !== null) {
          const reliefFor = emps.filter(emp => emp.employeeId == rf);
          return (activeEmpStatIds.indexOf(e.employmentStatusId) !== -1)
            && (e.employeeId !== reliefFor[0].employeeId && e.workSectionId == reliefFor[0].workSectionId) &&
            this.yearSched.filter(ys => ys.employeeId == e.employeeId && (moment(s.scheduleItemStart).isBetween(moment(ys.start), moment(ys.end)))).length == 0

        }
        else {
          return (activeEmpStatIds.indexOf(e.employmentStatusId) !== -1);
        }
      }
      else {
        return true;
      }
    }))
  );

  filteredReliefFor = combineLatest([this.employeeValues,this.employmentStatuses]).pipe(
    map(([emps,empStat]) => emps.filter(e => {
      const s = this.scheduleItemToEdit;
      const activeEmpStatIds = empStat.filter(es => es.isActiveStatus).map(es => es.employmentStatusId);
      if (s.scheduleItemId == 0) {
        return (activeEmpStatIds.indexOf(e.employmentStatusId) !== -1);
      }
      else {
        return true;
      }
    }))
  );


  filteredRes = combineLatest([this.resourceValues]).pipe(
    map(([res]) => res.filter(r => {
      const s = this.scheduleItemToEdit;
      if (s.scheduleItemId == 0 && s.scheduleItemStatusId != ScheduleItemStatusEnum.pending) {
        return (r.active);
      }
      else {
        return true;
      }
    }))
  );


  //Used for aims-lookup
  equipmentLookupColumns: AimsCommonTableHeader[] = [
    { key: 'equipmentIdOld', label: 'Asset ID', type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'equipmentGroup', label: 'Asset Group', type:AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'description', label: 'Description', type:AimsCommonTableHeaderType.STRING, filter: true },
  ];

  jobTitleLookupColumns: AimsCommonTableHeader[] = [
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING },
    { key: 'jobCategory', label: 'Category', type: AimsCommonTableHeaderType.STRING },
    { key: 'workSection', label: 'Work Section', type: AimsCommonTableHeaderType.STRING },
    { key: 'unionAffiliationCode', label: 'Union', type: AimsCommonTableHeaderType.STRING },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filter: false }
  ];

  employeeLookupColumns: AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'jobTitle', label: 'Job Title', type: AimsCommonTableHeaderType.STRING },
    { key: 'occDate', label: 'Occ Date', type: AimsCommonTableHeaderType.STRING },
    { key: 'occStatus', label: 'Occ Status', type: AimsCommonTableHeaderType.STRING },
    { key: 'assignmentDescription', label: 'Assignment', type: AimsCommonTableHeaderType.STRING },
    { key: 'siteCode', label: 'Permanent Site', type: AimsCommonTableHeaderType.STRING },
    { key: 'employmentType', label: 'Employment Type', type: AimsCommonTableHeaderType.STRING },
    { key: 'employeeStatus', label: 'Employee Status', type: AimsCommonTableHeaderType.STRING },
    { key: 'employmentStatus', label: 'Employment Status', type: AimsCommonTableHeaderType.STRING }
  ];

  resourceLookupColumns: AimsCommonTableHeader[] = [
    { key: 'fullName', label: 'Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'grade', label: 'Grade', type: AimsCommonTableHeaderType.STRING },
    { key: 'organizationName', label: 'Organization', type: AimsCommonTableHeaderType.STRING },
    { key: 'clearanceName', label: 'Clearance', type: AimsCommonTableHeaderType.STRING },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filter: false }
  ];

  carrierLookupColumns: AimsCommonTableHeader[]  = [
    { key: 'fullName', label: 'Name', type: AimsCommonTableHeaderType.STRING },
    { key: 'organizationName', label: 'Organization', type: AimsCommonTableHeaderType.STRING },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filter: false }
  ];

  arrivalOrDepartureCarrierLookupColumns: AimsCommonTableHeader[]  = [
    { key: 'id', label: 'ID', type: AimsCommonTableHeaderType.STRING },
    { key: 'siteCode', label: 'Site', type: AimsCommonTableHeaderType.STRING },
    { key: 'name', label: 'Flight', type: AimsCommonTableHeaderType.STRING },
    { key: 'organization', label: 'Carrier', type: AimsCommonTableHeaderType.STRING },
    { key: 'flightNumber', label: 'Flt/Tail #', type: AimsCommonTableHeaderType.STRING },
    { key: 'start', label: 'Arrival', type: AimsCommonTableHeaderType.STRING },
    { key: 'end', label: 'Departure', type: AimsCommonTableHeaderType.STRING },
    { key: 'notes', label: 'Notes', type: AimsCommonTableHeaderType.STRING }
  ];


  //***************************
  // Edit functions
  //***************************

  isNewSch(sch: ScheduleItem): boolean {
    return sch === undefined || sch.scheduleItemId == 0;
  }

  checkSiTypeOH(siType: number): boolean {
    return siType == ScheduleItemTypeEnum.overhire;
  }
  checkSiTypeRel(siType: number): boolean {
    return siType == ScheduleItemTypeEnum.relief;
  }

  public isEmpSiType(): boolean {
    if (this.scheduleItemTypeArr != null) {
      return this.scheduleItemTypeArr.filter(s => s.scheduleItemTypeId == this.scheduleItemToEdit.scheduleItemTypeId).map(s => s.isEmployeeSiType)[0];
    }
    return false;
  }

  firearmRequested: boolean = false;
  firearmRequestChange(event: MatCheckboxChange) {
    this.firearmRequested = event.checked;
  }

  travelArrangeReqChange(event: MatCheckboxChange) {
    this.scheduleItemToEdit.travelArrangeReq = event.checked;
  }

  public enableControls() {
    let disabledControl:boolean = !(this.isNewSch(this.scheduleItemToEdit) || this.calculateEditable())
                                   || (this.scheduleItemToEdit.employeeId == null && this.scheduleItemToEdit.resourceId == null);

    if (disabledControl) {
      this.formGroup.controls['travelArrangeReq'].disable();
      this.formGroup.controls['govBilled'].disable();
      this.formGroup.controls['companyBilled'].disable();
      this.formGroup.controls['purpose'].disable();
      this.formGroup.controls['meals'].disable();
      this.formGroup.controls['billeting'].disable();
      this.formGroup.controls['notes'].disable();
      this.formGroup.controls['oanumber'].disable();
      this.formGroup.controls['copanumber'].disable();

      this.formGroup.controls['classifiedAccess'] .disable();
      this.formGroup.controls['restrictedAccess'].disable();
      this.formGroup.controls['comsecaccess'].disable();
      this.formGroup.controls['teraccess'].disable();
      this.formGroup.controls['escortOnly'].disable();
      this.formGroup.controls['restrictedAreaPhotography'].disable();
      this.formGroup.controls['radarDowntime'].disable();
      this.formGroup.controls['transToTopCamp'].disable();
      this.formGroup.controls['firearmRequest'].disable();
    }
    else {
      this.formGroup.controls['travelArrangeReq'].enable();
      this.formGroup.controls['govBilled'].enable();
      this.formGroup.controls['companyBilled'].enable();
      this.formGroup.controls['purpose'].enable();
      this.formGroup.controls['meals'].enable();
      this.formGroup.controls['billeting'].enable();
      this.formGroup.controls['notes'].enable();
      this.formGroup.controls['oanumber'].enable();
      this.formGroup.controls['copanumber'].enable();

      this.formGroup.controls['classifiedAccess'] .enable();
      this.formGroup.controls['restrictedAccess'].enable();
      this.formGroup.controls['comsecaccess'].enable();
      this.formGroup.controls['teraccess'].enable();
      this.formGroup.controls['escortOnly']
      this.formGroup.controls['restrictedAreaPhotography'].enable();
      this.formGroup.controls['radarDowntime'].enable();
      this.formGroup.controls['transToTopCamp'].enable();
      this.formGroup.controls['firearmRequest'].enable();
    }
  }

  enableSiteDependentControls() {
    let disabledSanControl:boolean = !(this.isNewSch(this.scheduleItemToEdit) || this.calculateEditable()) || this.scheduleItemToEdit.siteId == null;
    if (disabledSanControl) {
      this.formGroup.controls['siteArrivalNoticeRequired'].disable();
    }
    else {
      this.formGroup.controls['siteArrivalNoticeRequired'].enable();
    }
    this.nameControlEnable();
  }

  overhireControlEnable() {
    if (this.scheduleItemToEdit.scheduleItemTypeId == this.siType.overhire) {
      this.formGroup.controls['overhireJtId'].enable();
    }
    else {
      this.formGroup.controls['overhireJtId'].disable();
    }
  }

  reliefForIdControlEnable() {
    if (this.scheduleItemToEdit.scheduleItemTypeId == this.siType.relief) {
      this.formGroup.controls['reliefForId'].enable();
    }
    else {
      this.formGroup.controls['reliefForId'].disable();
    }
  }

  nameControlEnable() {
    if (this.isEmpSiType()) {
      this.formGroup.controls['resourceId'].disable();
      this.formGroup.controls['employeeId'].enable();
    }
    else {
      this.formGroup.controls['resourceId'].enable();
      this.formGroup.controls['employeeId'].disable();
    }
  }

  scheduleItemStartControlEnable() {
    if (!(this.isNewSch(this.scheduleItemToEdit) || this.calculateEditable()) || (this.scheduleItemToEdit.scheduleItemTypeId == null ||
         (this.checkSiTypeOH(this.scheduleItemToEdit.scheduleItemTypeId) && this.scheduleItemToEdit.overhireJtId == null) ||
         (this.checkSiTypeRel(this.scheduleItemToEdit.scheduleItemTypeId) && this.scheduleItemToEdit.reliefForId == null)) ) {
      this.formGroup.controls['scheduleItemStart'].disable();
    }
    else {
      this.formGroup.controls['scheduleItemStart'].enable();
    }
  }

  // unused?
  startValueChange(event) {
    let dataItem: ScheduleItem = this.scheduleItemToEdit;
    if (dataItem.reliefForId != null) {
      this.reliefForId.next(dataItem.reliefForId);
      combineLatest([this.employeeValues, this.siteValues]).subscribe(([emps, travelSites]) => {
        dataItem.reliefForJtId = emps.find(e => e.employeeId == dataItem.reliefForId).jobTitleId;
        dataItem.siteId = emps.find(e => e.employeeId == dataItem.reliefForId).permanentSiteId;
        dataItem.jtWsId = emps.find(e => e.employeeId == dataItem.reliefForId).workSectionId;
        dataItem.siteArrivalNoticeRequired = travelSites.find(s => s.siteId == dataItem.siteId).sanRequired;

        this.formGroup.patchValue({ reliefForJtId : dataItem.reliefForJtId,
           siteArrivalNoticeRequired : dataItem.siteArrivalNoticeRequired,
           siteId :  dataItem.siteId,
           jtWsId : dataItem.jtWsId, } , {onlySelf:true} );
      });
    }
    else if (dataItem.overhireJtId != null) {
      this.overhireJtId.next(dataItem.overhireJtId);
      this.jobTitleValues.subscribe(jobTitles => {
        dataItem.jtWsId = jobTitles.find(j => j.jobTitleId == dataItem.overhireJtId).workSectionId;
        this.formGroup.patchValue({ jtWsId : dataItem.jtWsId, } , {onlySelf:true} );
      });
    }

    if (dataItem.scheduleItemTypeId == ScheduleItemTypeEnum.vacation) {
      dataItem.scheduleItemStatusId = ScheduleItemStatusEnum.pending;
      this.formGroup.patchValue({ scheduleItemStatusId : dataItem.scheduleItemStatusId } , {onlySelf:true} );
    }

    if (dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.flight && dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.notAvailable) {
      this.setCarriers(dataItem.siteId, dataItem.scheduleItemStart, dataItem.scheduleItemEnd);
    }
  }

  // unused?
  endValueChange(dataItem: ScheduleItem) {
    if (dataItem.reliefForId != null) {
      this.reliefForId.next(dataItem.reliefForId);
      combineLatest([this.employeeValues, this.siteValues]).subscribe(([emps, travelSites]) => {
        dataItem.reliefForJtId = emps.find(e => e.employeeId == dataItem.reliefForId).jobTitleId;
        dataItem.siteId = emps.find(e => e.employeeId == dataItem.reliefForId).permanentSiteId;
        dataItem.jtWsId = emps.find(e => e.employeeId == dataItem.reliefForId).workSectionId;
        dataItem.siteArrivalNoticeRequired = travelSites.find(s => s.siteId == dataItem.siteId).sanRequired;

        this.formGroup.patchValue({ reliefForJtId : dataItem.reliefForJtId,
           siteArrivalNoticeRequired : dataItem.siteArrivalNoticeRequired,
           siteId :  dataItem.siteId,
           jtWsId : dataItem.jtWsId, } , {onlySelf:true} );
      });
    }
    else if (dataItem.overhireJtId != null) {
      this.overhireJtId.next(dataItem.overhireJtId);
      this.jobTitleValues.subscribe(jobTitles => {
        dataItem.jtWsId = jobTitles.find(j => j.jobTitleId == dataItem.overhireJtId).workSectionId;
        this.formGroup.patchValue({ jtWsId : dataItem.jtWsId, } , {onlySelf:true} );
      });
    }

    if (dataItem.scheduleItemTypeId == ScheduleItemTypeEnum.vacation) {
      dataItem.scheduleItemStatusId = ScheduleItemStatusEnum.pending;
      this.formGroup.patchValue({ scheduleItemStatusId : dataItem.scheduleItemStatusId } , {onlySelf:true} );
    }

    if (dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.flight && dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.notAvailable) {
      this.setCarriers(dataItem.siteId, dataItem.scheduleItemStart, dataItem.scheduleItemEnd);
    }
  }

  statusValueChange(event: MatSelectChange) {
    this.scheduleItemToEdit.scheduleItemStatusId = event.value;
    this.enableControls();
  }

  typeValueChange(event: MatSelectChange) {
    let dataItem = this.scheduleItemToEdit;
    dataItem.scheduleItemTypeId = event.value;

    this.scheduleItemStartControlEnable();
    this.overhireControlEnable();
    this.reliefForIdControlEnable();

    this.scheduleItemTypeValues.subscribe(vals => {
      let typeObj = vals.filter(st => st.scheduleItemTypeId == dataItem.scheduleItemTypeId)[0];
      dataItem.scheduleItemStatusId = typeObj.requiresApproval ? ScheduleItemStatusEnum.pending : ScheduleItemStatusEnum.approved;
      this.formGroup.patchValue({ scheduleItemStatusId : dataItem.scheduleItemStatusId, } , {onlySelf:true} );

      if (typeObj.isEmployeeSiType) {
        dataItem.resourceId = null;
        this.formGroup.patchValue({ resourceId : dataItem.resourceId } , {onlySelf:true} );

        this.employeeValues.subscribe();
        this.jobTitleValues.subscribe();
        if (typeObj.scheduleItemTypeId == this.siType.vacation || typeObj.scheduleItemTypeId == this.siType.notAvailable) {
          dataItem.siteArrivalNoticeRequired = false;
          this.formGroup.patchValue({ siteArrivalNoticeRequired : dataItem.siteArrivalNoticeRequired } , {onlySelf:true} );
        }

        if (typeObj.scheduleItemTypeId == this.siType.relief || typeObj.scheduleItemTypeId == this.siType.overhire) {
          if (typeObj.scheduleItemTypeId == this.siType.relief) {
            dataItem.overhireJtId = null; dataItem.overhireJt = null; dataItem.jtWsId = null;
            this.formGroup.patchValue({ overhireJtId : dataItem.overhireJtId,
                                        overhireJt : dataItem.overhireJt,
                                        jtWsId : dataItem.jtWsId } , {onlySelf:true} );
          };
          if (typeObj.scheduleItemTypeId == this.siType.overhire) {
            dataItem.reliefForId = null; dataItem.reliefFor = null; dataItem.reliefForJtId = null; dataItem.jtWsId = null;
            this.formGroup.patchValue({ reliefForId : dataItem.reliefForId,
                                        reliefFor : dataItem.reliefFor,
                                        reliefForJtId : dataItem.reliefForJtId,
                                        jtWsId : dataItem.jtWsId } , {onlySelf:true} );
          };
        }
        else {
          dataItem.overhireJtId = null;
          dataItem.overhireJt = null;
          dataItem.jtWsId = null;
          dataItem.reliefForId = null;
          dataItem.reliefFor = null;
          dataItem.reliefForJtId = null;

          this.formGroup.patchValue({ overhireJtId : dataItem.overhireJtId,
                                      overhireJt : dataItem.overhireJt,
                                      jtWsId : dataItem.jtWsId,
                                      reliefForId : dataItem.reliefForId,
                                      reliefFor : dataItem.reliefFor,
                                      reliefForJtId : dataItem.reliefForJtId, } , {onlySelf:true} );
        }
      }
      else if (!typeObj.isEmployeeSiType) {
        dataItem.employeeId = null;
        this.formGroup.patchValue({ employeeId : dataItem.employeeId } , {onlySelf:true} );
        this.resourceValues.subscribe();
      }

      //Default checkbox values when type changed
      this.formGroup.patchValue({
        billeting : typeObj.billetingDefault,
        meals : typeObj.mealsDefault,
        companyBilled : typeObj.companyBilledDefault,
        govBilled : typeObj.govBilledDefault
        } , {onlySelf:true} );

      dataItem.billeting = typeObj.billetingDefault;
      dataItem.meals = typeObj.mealsDefault;
      dataItem.companyBilled = typeObj.companyBilledDefault;
      dataItem.govBilled = typeObj.govBilledDefault;

      this.nameControlEnable();
    });
  }

  nameValueChange(event) {
    let dataItem = this.scheduleItemToEdit;
    dataItem.employeeId = event.employeeId;
    dataItem.resourceId = event.resourceId;

    if (dataItem.scheduleItemTypeId == ScheduleItemTypeEnum.flight) {
      dataItem.carrierId = dataItem.resourceId;
      this.formGroup.patchValue({ carrierId : dataItem.carrierId } , {onlySelf:true} );
    }

    combineLatest([this.employeeValues, this.resourceValues]).subscribe(([emps, res]) => {
      if (dataItem.employeeId != null) {
        dataItem.clearanceId = emps.find(e => e.employeeId == dataItem.employeeId).clearanceId;
        this.formGroup.patchValue({ clearanceId : dataItem.clearanceId } , {onlySelf:true} );

        if (dataItem.reliefForId != null) {
          dataItem.reliefForJtId = emps.find(e => e.employeeId == dataItem.reliefForId).jobTitleId;
          dataItem.jtWsId = emps.find(e => e.employeeId == dataItem.reliefForId).workSectionId;
          this.formGroup.patchValue({ reliefForJtId : dataItem.reliefForJtId,  jtWsId : dataItem.jtWsId } , {onlySelf:true} );
        }

        if (dataItem.employeeId == this.user.employeeId) {
          dataItem.scheduleItemStatusId = ScheduleItemStatusEnum.pending;
          this.formGroup.patchValue({ scheduleItemStatusId : dataItem.scheduleItemStatusId } , {onlySelf:true} );
        }
      }
      else if (dataItem.resourceId != null) {
        dataItem.clearanceId = res.find(r => r.resourceId == dataItem.resourceId).clearanceId;
        this.formGroup.patchValue({ clearanceId : dataItem.clearanceId } , {onlySelf:true} );
      }

      this.enableControls();
    });

    this.enableControls();
  }

  siteValueChange(event: MatSelectChange) {
    let dataItem: ScheduleItem = this.scheduleItemToEdit;
    dataItem.siteId = event.value;

    if (dataItem.siteId != null) {
      this.siteValues.subscribe(travelSites => {
        if (dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.vacation && dataItem.scheduleItemTypeId != ScheduleItemTypeEnum.notAvailable) {
          this.setCarriers(dataItem.siteId, dataItem.scheduleItemStart, dataItem.scheduleItemEnd);
          dataItem.siteArrivalNoticeRequired = travelSites.find(s => s.siteId == dataItem.siteId).sanRequired;
        }
        else {
          dataItem.siteArrivalNoticeRequired = false;
        }

        this.formGroup.patchValue({ siteArrivalNoticeRequired : dataItem.siteArrivalNoticeRequired } , {onlySelf:true} );
        // this.formGroup.controls.resourceId.enable();
        this.formGroup.controls.carrierId.enable();

        this.enableSiteDependentControls();
      });
    }
  }

  carrierChange(event) {
    this.scheduleItemToEdit.carrierId = event.carrierID;
    if (event.resourceId != null) {
      this.formGroup.controls['flightNumber'].enable();
    }
    else {
      this.formGroup.controls['flightNumber'].disable();
    }
  }

  approveFirearm(f: SchFirearms) {
    f.approvedOn = new Date();
    f.approvedById = this.user.employeeId;
    f.disapprovedOn = null;
    f.disapprovedById = null;
  }

  disapproveFirearm(f: SchFirearms) {
    f.disapprovedOn = new Date();
    f.disapprovedById = this.user.employeeId;
    f.approvedOn = null;
    f.approvedById = null;
  }

  addTR: boolean = false;
  addTravelRequest() {
    this.addTR = true;
    this.formGroup.patchValue({ addTR:true}, {onlySelf:true} );
    this.formGroup.markAsDirty();
  }

  ngOnInit() {
    this.trLegData = this.trLegHub.getHot(`trLegHub?siId=${this.scheduleItemToEdit.scheduleItemId}`).pipe(
    map(legArr => legArr.sort((a, b) => a.travelRequestId == b.travelRequestId && a.travelLeg < b.travelLeg ? -1 : a.travelRequestId == b.travelRequestId && a.travelLeg > b.travelLeg ? 1 : 0)
    )
  );

    this.overhireJtId.subscribe(val => {
      this.scheduleItemToEdit.overhireJtId = val;
      this.scheduleItemStartControlEnable();
    });
    this.reliefForId.subscribe(val => {
      this.scheduleItemToEdit.reliefForId = val;
      this.scheduleItemStartControlEnable();
    });

    this.employeeValues.subscribe();
    this.jobTitleValues.subscribe();

    this.scheduleItemTypeValues.subscribe(vals => {
      this.scheduleItemTypeArr = vals;

      this.nameControlEnable();
      this.reliefForIdControlEnable();
    });

    this.enableControls();
    this.overhireControlEnable();
    this.scheduleItemStartControlEnable();
    this.enableSiteDependentControls();

    this.firearmRequested = this.scheduleItemToEdit.firearmRequest;

    if (this.scheduleItemToEdit.scheduleItemTypeId != ScheduleItemTypeEnum.flight && this.scheduleItemToEdit.scheduleItemTypeId != ScheduleItemTypeEnum.notAvailable) {
      this.setCarriers(this.scheduleItemToEdit.siteId, this.scheduleItemToEdit.scheduleItemStart, this.scheduleItemToEdit.scheduleItemEnd);
    }
  }

 // Inventory
  partsTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'return', label: 'Return', type: 'button',
            events: { click: (element) => this.openReturnPopup(element) }, filter: false },
    { key: 'inventoryItem.barcode', label: 'Barcode', type: 'number', editable: false },
    { key: 'inventoryItem.description', label: 'Description', type: 'string', width: 300, editable: false },
    { key: 'quantity', label: 'Quantity', type: 'dynamic', width: 100 },
    { key: 'inventoryItem.unitOfIssueId', label: 'Unit of Issue', type: 'string', width: 60, editable: false  },
    { key: 'partCost', label: 'Part Cost', type: 'dynamic', filter: false, editable: false },
  ];

  partsSubTableHeader: AimsCommonTableHeader[] = [
    { key: 'quantity', label: 'Quantity', type: 'number', filter: false },
    { key: 'unitCost', label: 'Unit Cost', type: 'dynamic', filter: false },
  ];

  partsTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };

  attachedItems: any[] = []; //InvAttachedItem

  // Inventory Parts begin

  public loadAttachedItems(scheduleItemId: number) {
    if (scheduleItemId == 0) {
      return;
    }

    if (this.inventoryAllowed()) {
      this.showSpinner = true;
      this.transferHttp.get(`Inventory/GetScheduleItemItems?scheduleItemId=${scheduleItemId}` ).subscribe(retval => {
            this.attachedItems = retval;
            this.fillInQuantity();
            this.showSpinner = false;
      });
    }
  }

  fillInQuantity() {
    this.attachedItems.forEach(ai => {
      ai.quantity = this.getAttachedItemPulledQuantity(ai.attachedItemId);
    });
  }

  public addItemToScheduleItem(event) {
      this.showSpinner = true;
      var url = `Inventory/AddPartToScheduleItem?scheduleItemId=${this.scheduleItemToEdit.scheduleItemId}&inventoryItemId=${event.inventoryItem.inventoryItemId}&quantity=${event.quantity}`;
      this.transferHttp.put(url, null)
        .subscribe(retVal => {
        this.loadAttachedItems(this.scheduleItemToEdit.scheduleItemId);
      });
  }

  public getAttachedItemPulledQuantity(attachedItemId: number): number {
    const sum: number = this.attachedItems.filter(wi => wi.attachedItemId === attachedItemId)[0]
      .invAttachedItemPulled
      .map(i => i.quantity)
      .reduce((sum, current) => sum + current, 0);
    return sum;
  }

  public getAttachedItemPulledCost(attachedItemId: number): number {
    if (attachedItemId == 0) {
      return 0;
    }

    const totalCost: number = this.attachedItems.filter(wi => wi.attachedItemId === attachedItemId)[0].invAttachedItemPulled
      .map(i => i.quantity *  i.inventoryItemReceived.costPerUnit)
      .reduce((sum, current) => sum + current, 0);
    return totalCost;
  }

  public getTotalAttachedItemsPulledCost(): number {
    var totalCost: number = 0;
      this.attachedItems.forEach(iwi => {
        if (iwi.invAttachedItemPulled[0].attachedItemPulledId == 0) {
          totalCost += 0;
        }
        else {
        totalCost += iwi.invAttachedItemPulled
            .map(i => i.quantity *  i.inventoryItemReceived.costPerUnit)
            .reduce((sum, current) => sum + current, 0);
        }
      })
    return totalCost;
  }

  public openReturnPopup(itemToReturn: InvAttachedItem) {
    const originalQuantity = this.getAttachedItemPulledQuantity(itemToReturn.attachedItemId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
            data: {
                btnOkText: 'Return',
                header: 'Return Quantity',
                content: InventoryReturnPopupComponent,
                contentData: { itemToReturn: itemToReturn, maxReturnableQuantity: originalQuantity },
            },
            disableClose: true
        });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.returnInventoryItemQuantity(itemToReturn.attachedItemId, dialogResult.returnedQuantity);
      }
    });
  }

  public returnInventoryItemQuantity(attachedItemId: number, returnedQuantity: number) {
    this.spinnerText = "Returning Inventory Item...";
    this.showSpinner = true;

    var url = `inventory/RemoveQuantityFromAttachedItem?attachedItemId=${attachedItemId}&quantityToRemove=${returnedQuantity}`;
    this.transferHttp.put(url, null)
      .subscribe({
        next: _ => {
          this.loadAttachedItems(this._scheduleItemToEdit.scheduleItemId);
          this.showSpinner = false;
        },
        error: err => {
          this.showSpinner = false;
        }
      });
  }

}
